import { useEffect } from 'react';

import { shouldRenderQuestion } from '../helpers/shouldRenderKycQuestion';
import { addOrUpdateFormFields } from '../store/applicationform';
import { IFieldState } from '../store/applicationform/applicationFormTypes';
import { Kyc } from '../types/KycTypes';
import { useAppDispatch } from '.';

export const useFieldValueClearer = (data: Kyc | undefined, kycAnswerFieldStates: IFieldState[]) => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const allQuestions = data?.groups.flatMap((group) => group.questions) ?? [];
        const nonVisibleQuestions =
            allQuestions.filter((question) => !shouldRenderQuestion(question, allQuestions, kycAnswerFieldStates)) ??
            [];

        const clearFieldStates = nonVisibleQuestions
            .filter(
                (question) =>
                    kycAnswerFieldStates.find((s) => s.fieldName === 'KYC_' + question.groupId + '_' + question.name)
                        ?.value !== '',
            )
            .map((question) => ({
                fieldName: 'KYC_' + question.groupId + '_' + question.name,
                value: '',
                label: '',
            }));

        if (clearFieldStates.length) {
            dispatch(addOrUpdateFormFields(clearFieldStates));
        }
    }, [data, kycAnswerFieldStates, dispatch]);
};
